@if (auth.isInternal() && !isClientview) {
  <div class="btn-group notifications" dropdown (onShown)="openMessages()" container="body">
    <div class="bell d-flex align-items-center justify-content-center position-relative">
      <div class="d-flex align-items-center justify-content-center cursor-pointer" type="button" dropdownToggle aria-controls="dropdown-animated">
        <i class="far fa-bell nav-secondary fa-lg"></i>
        @if (auth.getUser()?.hasNewMessages) {
          <span class="count">&nbsp;</span>
        }
      </div>
    </div>
    <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu py-0 shadow notifications-content" role="menu">
      <li class="py-2 or-primary-bg text-white">Notifications
        <!-- <a [routerLink]="['/alert-settings']" class="float-right">
          <i class="fas fa-expand cursor-pointer opacity-90 text-white"></i>
        </a> -->
      </li>
      @if (!loading) {
        <div class="scrollbar overflow-y">
          @for (message of items; track message) {
            <li>
              <div class="media cursor-pointer" (click)="navigateFromAlert(message)">
                <!-- ProjectStatus -->
                @if (['ProjectAllocation','ProjectCreated','ProjectStatusClosed','ProjectStatusInvoiced','ProjectStatusLive','ProjectStatusPaused','ProjectOverQuota'].includes(message.type)) {
                  <i class="align-self-center notification-icon fak fa-project-alerts or-primary"></i>
                }
                @if (['VendorCostConfirmed','VendorOverQuota','VendorOverQuotaGroup','VendorProjectStop','VendorReconciledID','VendorStatus'].includes(message.type)) {
                  <i class="align-self-center notification-icon fa-md fa-vendors fak or-primary"></i>
                }
                @if (['NoteAdded'].includes(message.type)) {
                  @if (isBidAlert(message)) {
                    <i class="align-self-center notification-icon fa-md fas fa-file-invoice-dollar or-primary"></i>
                  } @else {
                    <i class="align-self-center notification-icon fak fa-notes fa-md or-primary"></i>
                  }
                }
                @if (['SecondaryPmChange'].includes(message.type)) {
                  <i class="align-self-center notification-icon fa-md fa-team fak or-primary"></i>
                }
                @if (['DOR Alert','OQ Alert'].includes(message.type)) {
                  <i class="align-self-center notification-icon fak fa-project-alerts or-primary"></i>
                }
                @if (['MilestoneEndDate','TasksAssignedToMe','TasksStatusChange'].includes(message.type)) {
                  <i class="align-self-center notification-icon fa-md fa-tasklist fak or-primary"></i>
                }
                <div class="media-body">
                  <h6 class="my-0 or-secondary font-weight-normal">{{ message.title }}</h6>
                  @if (message.isNew) {
                    <small class="badge badge-pill badge-success text-white text-uppercase float-right mt-1">new</small>
                  }
                  <span><i class="far fa-clock fa-sm pr-1"></i>{{ message.time }}</span>
                </div>
              </div>
            </li>
          }
        </div>
      }
      @if (loading) {
        <li>
          <div class="row p-2">
            <div class="col d-flex justify-content-center">
              <div class="loading loading-lg"></div>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
}

@if (auth.isVendor()) {
  <div class="btn-group notifications" dropdown (onShown)="openVendorMessages()" container="body">
    <div class="bell d-flex align-items-center justify-content-center position-relative">
      <div class="d-flex align-items-center justify-content-center cursor-pointer" type="button" dropdownToggle aria-controls="dropdown-animated">
        <i class="far fa-bell text-secondary fa-lg"></i>
        @if(vendorHasNewNotes) {<span class="count">&nbsp;</span>}
      </div>
    </div>
    <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu py-0 shadow notifications-content" role="menu">
      <li class="py-2 or-primary-bg text-white">Notifications
        <!-- <a [routerLink]="['/alert-settings']" class="float-right">
          <i class="fas fa-expand cursor-pointer opacity-90 text-white"></i>
        </a> -->
      </li>

      <div class="scrollbar overflow-y">
        @for (note of vendorNotes; track note) {
          <li>
            <div class="media" (click)="openNotesSession(note)">
              @if (note.bidId) {
                <i class="align-self-center notification-icon fa-md fas fa-file-invoice-dollar or-primary"></i>
              } @else {
                <i class="align-self-center notification-icon fa-md fa-fielding-note fak or-primary"></i>
              }
              <div class="media-body">
                @if (note.bidId) {
                  <a class="font-weight-bold or-primary-link text-white"><h6 class="my-0 or-secondary">New note added to Bid {{ note.projectCode }}</h6></a>
                } @else {
                  <a class="font-weight-bold or-primary-link text-white"><h6 class="my-0 or-secondary">Fielding note added for Project {{ note.projectName }}</h6></a>
                }
                <span><i class="far fa-clock fa-sm pr-1"></i>{{ note.time }}</span>
              </div>
            </div>
          </li>
        }
      </div>
    </ul>
  </div>
}

@if (auth.isClient()) {
  <div class="btn-group notifications" dropdown (onShown)="openClientMessages()" container="body">
    <div class="bell d-flex align-items-center justify-content-center position-relative">
      <div class="d-flex align-items-center justify-content-center cursor-pointer" type="button" dropdownToggle aria-controls="dropdown-animated-client">
        <i class="far fa-bell text-secondary fa-lg"></i>
        @if (clientHasNewNotes) {<span class="count">&nbsp;</span>}
      </div>
    </div>
    <ul id="dropdown-animated-client" *dropdownMenu class="dropdown-menu py-0 shadow notifications-content" role="menu">
      <li class="py-2 or-primary-bg text-white">Notifications</li>
      <div class="scrollbar overflow-y">
        @for (note of clientNotes; track note) {
          <li>
            <div class="media" (click)="openNotesSession(note)">
              <i class="align-self-center notification-icon fak fa-notes fa-md or-primary"></i>
              <div class="media-body">
                <h6 class="my-0 or-secondary">Note added for Project {{ note.projectName }}</h6>
                <span><i class="far fa-clock fa-sm pr-1"></i>{{ note.time }}</span>
              </div>
            </div>
          </li>
        }
        @if (clientNotes.length === 0) {
          <li class="p-3 text-center text-muted">No new notifications</li>
        }
      </div>
    </ul>
  </div>
}
